/* eslint react/no-unescaped-entities: off */
import React, { Component } from 'react';
import './GobiCashmerePillarPage.scss';
import PillarSide from './PillarSide';
import ScrollToTop from './ScrollToTop';
import Header from './Header';
import SocialWidget from './SocialWidget';
import { StickyContainer } from 'react-sticky';

export default class GobiCashmerePillarPage extends Component {
  render() {
    return (
      <div>
        <div id="shopify-section-page-pillar1-template" className="shopify-section">
          <div className="page-blocks">
            <div>
              <div>
                <div className="rte">
                  <Header activeLink="gobi-cashmere" />
                  <div className="pilla_slider">
                    <div
                      className="sl_back"
                      style={{
                        backgroundImage:
                          'url(https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_3_b1ea4079-6e85-4aa4-b47b-485508932598.png?v=1584588670)',
                      }}
                    >
                      <div className="top_center">
                        <h1>GOBI CASHMERE</h1>
                        <p>
                          Im Jahr 1981 gegründete “GOBI” ist der erste Kaschmirhersteller der Mongolei und einer der
                          größten vertikal integrierten Kaschmirproduzenten der Welt.
                        </p>
                      </div>
                    </div>
                  </div>
                  <StickyContainer className="pillar-container" id="containerSelecorFocus">
                    <div className="sidebar-bg">
                      <PillarSide />
                    </div>
                    <div className="pilla_main">
                      <SocialWidget />
                      <section id="our-story">
                        <div className="sec_tt">
                          <div className="top">
                            <span>1</span>
                            <h2>Teil</h2>
                            <ScrollToTop />
                          </div>
                          <div className="bottom">
                            <h1>Unsere Geschichte</h1>
                          </div>
                        </div>
                        <div className="content">
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/1953/2845/files/dambadarjaa.jpg?v=1585118324"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>GOBI’s Management-Team trifft japanischen Botschafter in der Mongolei, 1977</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              Im Jahr 1981 gegründete “GOBI” ist der erste Kaschmirhersteller der Mongolei und einer der
                              größten vertikal integrierten{' '}
                              <a href="https://www.gobicashmere.com/de/pillar/gobi-cashmere">Kaschmirproduzenten </a>
                              der Welt, der 2.5 Millionen Produkte im Jahr produziert.
                            </p>
                            <p>
                              Mit einer Kapazität von 1100 Tonnen Rohkaschmir zu verarbeiten, verwaltet GOBI die gesamte
                              Wertschöpfungskette – von der Beschaffung des rohen Kaschmirs direkt von den nomadischen
                              Hirten bis zur Verarbeitung und Herstellung von Kaschmirprodukten in riesigen Werken in
                              Ulaanbaatar, Mongolei.
                            </p>
                            <p>
                              GOBI vereinigt Innovationen und Kreativität mit den unentdeckten Möglichkeiten von
                              Kaschmir, um im Vordergrund der Welt des Modedesigns zu stehen.
                            </p>
                            <p>
                              In den letzten vier Jahrzehnten haben wir sechs unteschiedliche Markenlinien entwickelt:
                              GOBI, GOBI ORGANIC, YAMA, GOYO, HERDERS und KID GOYO. Unsere Produktlinien werden von
                              unseren Kunden unabhängig von Jahreszeit, Anlass oder Ort sehr geschätzt.
                            </p>
                          </div>
                        </div>
                      </section>
                      <section className="manufacturing">
                        <div className="sec_tt">
                          <div className="top">
                            <span>2</span>
                            <h2>Teil</h2>

                            <ScrollToTop />
                          </div>
                          <div className="bottom">
                            <h1>Herstellung</h1>
                          </div>
                        </div>
                        <div className="content">
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/1953/2845/files/da2.png?v=1585115589"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>Kammgarnspinnerei in der Fabrik von GOBI.</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              GOBI beschafft Kaschmirfasern mit Transparenz, indem wir ein vertikal integriertes
                              Herstellungssystem antreiben, bei dem kein einziger Prozess unbemerkt bleibt. Die
                              mongolische Tradition bleibt durch die Handkamm-Methode erhalten und sie ermöglicht uns
                              unsere Kunden mit qualitativ hochwertigeres Endprodukt zu besorgen. GOBI schätzt die „Fair
                              Trade“ – Praktik und hat jeden unnötigen Zwischenhändler aus dem{' '}
                              <a href="https://www.gobicashmere.com/de/pages/our-production">Gewinnprozess</a> des
                              Kaschmirs abgeschafft, um eine faire Bezahlung für die Hirten zu gewährleisten. Jeder
                              Einkauf unserer geliebten Kunden wird nicht nur durch die hohe Qualität des Produkts
                              bewertet, sondern auch durch die direkte Unterstützung der mongolischen
                              Hirtengemeinschaft. Die GOBI’s Vision der besten Kaschmir der Welt ist die Grundlage einer
                              umweltbewussten und nachhaltigen Wertschöpfungskette.
                            </p>
                          </div>
                        </div>
                        <div className="content">
                          <h2 className="med_tt">Fabrik</h2>
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_3.png?v=1584414790"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>GOBI’s Kaschmirherstellungsfabrik.</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              GOBI schafft eine breite Produkt- und Kollektionspalette aus hochwertigen Rohstoffen
                              kombiniert mit innovativen Technologien und jahrelanger Handwerkskunst anzufertigen.
                            </p>
                            <p>
                              Vom Rohstoffkauf bei Hirten bis zum fertigen Endprodukt hält GOBI strikt an die
                              technologischen Verfahren ein. Außerdem ist ein Qualitätsmanagementsystem implementiert,
                              das auf die ständige Verbesserung seiner Produktionsstätten abzielt.
                            </p>
                            <p>
                              Wir haben in jeden Verarbeitungsprozessen eigene innerbetriebliche Laboratorien, die von
                              Rohstoffen bis zu Endprodukte testen. Unsere Laboratorien erfüllen die Kriterien der
                              internationalen Normen für das Qualitätsmanagementsystem ISO 9001: 2015 und den Normen ISO
                              / IEC 17025. Außerdem gewährleistet GOBI den Standard für das
                              Arbeitsschutzmanagementsystem ISO 45001: 2018 und den Umweltmanagementsystemstandard ISO
                              14001: 2015.
                            </p>
                          </div>
                        </div>
                        <div className="content">
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/1953/2845/files/da3.png?v=1585115589"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>100% Kaschmir mit umfassender Farbenauswahl bei GOBI.</p>
                            </div>
                          </div>
                          <div className="text">
                            {/* <p>GOBI strives to deliver the most exquisite and luxurious <a href="https://blog.gobicashmere.com/cashmere-guide-to-packing-for-a-ski-trip-for-her">experience in cashmere</a> both domestically and globally.</p> */}
                          </div>
                        </div>
                        <div className="content">
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_6.png?v=1584414877"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>Gobi ist stolz auf die großen Mitarbeiterinnen.</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              Die Arbeit der insgesamt 2.500 hochqualifizierten Mitarbeitern an verschiedenen
                              Produktionsstätten beginnt, sobald der Rohstoff an das GOBI-Werk geliefert wird. Als eines
                              der beispielhaften Unternehmen der Mongolei, ermöglicht GOBI der Frauen Arbeitsplätze, und
                              das Unternehmen achtet im Vordergrung auf die Gleichberechtigung. 72% der Belegschaft
                              besteht aus Frauen, die grossartige Handwerkkunst besitzen. Das ist einer der Gründe,
                              warum GOBI noch so erfolgreich ist.
                            </p>
                          </div>
                        </div>
                      </section>
                      <section className="sustainability">
                        <div className="sec_tt">
                          <div className="top">
                            <span>3</span>
                            <h2>Teil</h2>
                            <ScrollToTop />
                          </div>
                          <div className="bottom">
                            <h1>Nachhaltigkeit</h1>
                          </div>
                        </div>
                        <div className="content">
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_19.png?v=1584613872"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>Kaschmirziegenherde und Besucher, Sergelen, Provinz Tuv Aimag, 2019.</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              Natur, Harmonie und Schutz sind die bedeutende Werte mongolischer Hirten. Die mongolische
                              Nomaden, die seit Tausenden von Jahren in der riesigen Steppe leben, schafften eine
                              einzigartige Tradition. Diese Vision inspirierte und erweckte die Wille, dass das
                              Unternehmen GOBI traditionelles Erbe mit{' '}
                              <a href="https://www.gobicashmere.com/de/pages/sustainability">
                                modernen nachhaltigen Initiativen{' '}
                              </a>
                              zu verbinden.
                            </p>
                            <p>
                              Das Unternehmen GOBI ist Mitglied der Allianz für Nachhaltige Faserstoffe (ANF). Die ANF
                              wurde 2015 gegründet und ist eine gemeinnützige internationale Organisation, die mit der
                              erweiterten Kaschmir-Wertschöpfungskette von Hirten bis zu Einzelhändlern arbeitet. Sie
                              bietet eine unabhängige und nicht wettbewerbsfähige Plattform an. Die
                              Kaschmir-End-to-End-Wertschöpfungsketten, Nichtregierungsorganisationen und
                              Regierungsorganisationen können sich da zusammentreffen, um ein gemeinsames Interesse an
                              der Sicherung der Nachhaltigkeit in der Kaschmirbranche zu entwickeln.
                            </p>
                          </div>
                        </div>
                        <div className="content" style={{ marginTop: '60px' }}>
                          <h2 className="med_tt">
                            DIE ALLIANZ FÜR NACHHALTIGE FASERSTOFFE UND GOBI HABEN DREI KLARE ZIELE:
                          </h2>
                          <div className="goal">
                            <div>
                              <div className="tt">
                                <span>UMWELT:</span>
                              </div>
                              <div className="det">
                                <p>Belastbarkeit der Umwelt in Kaschmir produzierenden Regionen.</p>
                              </div>
                            </div>
                            <div>
                              <div className="tt">
                                <span>GEMEINDE:</span>
                              </div>
                              <div className="det">
                                <p>
                                  Langfristig verbesserte Perspektiven für Hirtengemeinschaften, die von Kaschmirmärkten
                                  abhängig sind.
                                </p>
                              </div>
                            </div>
                            <div>
                              <div className="tt">
                                <span>TIER:</span>
                              </div>
                              <div className="det">
                                <p>
                                  Gewährleistung des Tierschutzes innerhalb der verschiedenen Stufen der
                                  Kaschmirproduktion.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="content">
                          <h2 className="med_tt">
                            DIE PARTNERSCHAFT VON GOBI MIT DER ANF: NACHHALTIGES KASCHMIRPROJEKT
                          </h2>
                          <div className="text">
                            <p>
                              Seit 2018 läuft das von dem Unternehmen GOBI finanzierte „Nachhaltige Kaschmirprojekt“.
                              Und das Projekt zielt auf die Unterstützung einer nachhaltigen Zusammenarbeit zur
                              Verringerung und Verhinderung der Entwertung von Weideland und zum Schutz der Tiere in der
                              ländlichen Mongolei ab. Das umfassende Programm vereint die Beteiligten der
                              Kaschmir-Wertschöpfungskette. So verbessert das Projekt das Leben der Hirten und
                              entwickelt nachhaltige Kaschmirindustrien in den Provinzen Dornogobi und Bayankhongor.
                            </p>
                            <p>
                              Die GOBI’s Beteiligung an den nachhaltigen Kaschmir ist eine kontinuierliche Massnahme und
                              Bemühung, die von engagierten Organisationen wie der ANF unterstützt wird.
                            </p>
                          </div>
                        </div>
                      </section>
                      <section className="our-brand">
                        <div className="sec_tt">
                          <div className="top">
                            <span>4</span>
                            <h2>Teil</h2>
                            <ScrollToTop />
                          </div>
                          <div className="bottom">
                            <h1>UNSERE MARKEN</h1>
                          </div>
                        </div>
                        <div className="content">
                          <div className="text" style={{ marginBottom: '30px' }}>
                            <p>
                              Das Unternehmen GOBI besitzt sechs einzigartige Marken. Um seine immer vermehrende Kunden
                              zufrieden zu stellen, spiegeln jede sechs Markendesigns unterschiedliche Merkmale und
                              Charakteristiken wider.
                            </p>
                          </div>
                          <div className="grid">
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/XMLID_4.png?v=1584419042"
                                  alt="GOBI"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  GOBI ist die Premium-Kaschmirmarke, die{' '}
                                  <a href="https://www.gobicashmere.com/de/pillar/cashmere-is-for-everyone">
                                    {' '}
                                    für jeden{' '}
                                  </a>{' '}
                                  erschwingliche Luxus ermöglicht . Sie bietet komplette Garderobenlösungen für alle
                                  Gelegenheiten und sorgt für dauerhaften Stil und Selbstvertrauen. Es wurde entworfen
                                  für diejenigen, die mühelos schick aussehen und sich dabei gut fühlen möchten.
                                </p>
                              </div>
                            </div>
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Group_227.png?v=1584615351"
                                  alt="YAMA"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  GOBI hat vor kurzem die Premiummarke „YAMA“ eingeführt, die Schönheit und Eleganz
                                  ausstrahlt. Feine Naturfasern und italienisches Design treffen sich zusammen, um mit
                                  100% mongolischem Kaschmir einen trendigen und dennoch klassischen Look zu kreieren.
                                  Der Markenname „YAMA“ kommt von Mongolischen und bedeutet „Ziege“, was den Ursprung
                                  von Kaschmir kennzeichnet. Ausserdem heisst die japanische Definition dafür
                                  "Berggipfel", was die höchste Qualität unseres Kaschmirs symbolisiert.
                                </p>
                              </div>
                            </div>
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Group_228.png?v=1584615357"
                                  alt="GOBI ORGANIC"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  Weiß, beige, warmgrau und braun sind die natürlich vorkommenden Kaschmir Farbtöne der
                                  mongolischen Ziegen. Jede Farbe hat ihre eigenen Merkmale. GOBI verändert in keiner
                                  Produktionsphase die organische Qualität von mongolischem Kaschmir. Ungefärbte und
                                  ungebleichte Produkte von „GOBI ORGANIC“ stellen die Exklusivität der organischen
                                  Materialien dar, die ohne Kompromisse hergestellt werden.
                                </p>
                              </div>
                            </div>
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Group_229.png?v=1584615363"
                                  alt="GOYO"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  „GOYO“ besitzt eine eigene Besonderheit, die von Kunden der ganzen Welt geschätzt
                                  wird. Und die Marke ist eine Kombination aus verspielten Farben und kreativen Designs,
                                  eine Harmonie der Tradition und Modern. Wir sammeln nur Rohstoffe von höchster
                                  Qualität und produzieren luxuriöse Kaschmir-Kleidungsstücke. Dabei verwenden wir
                                  international beste Verfahren und modernste Technologien, um die Erwartungen unserer
                                  Kunden zu übertreffen.
                                </p>
                              </div>
                            </div>
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Layer_1.png?v=1584615370"
                                  alt="HERDERS"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  Die Marke „HERDERS“ ist eine nachhaltige Kaschmir-Initiative, die von dem Unternehmen
                                  GOBI gestützt wird. Die Ziele des Projekts sind die Erhaltung des natürlichen und
                                  nomadischen Tradition rund um die Kaschmirproduktion durch die Einführung eines
                                  nachhaltigen Geschäftsmodells zur Entschädigung der Hirten. Das erste Ziel ist die
                                  Entwertung des Weidelands durch den Herdengrößen zu verkleinern. Zweitens ist mit den
                                  Hirtengemeinschaften zusammenzuarbeiten, um die nachhaltigste Rohkaschmirquelle
                                  digital verfolgen zu können. Damit kann die Wertschöpfungskette vereinfacht werden.
                                </p>
                              </div>
                            </div>
                            <div className="col_6">
                              <div className="logo">
                                <img
                                  src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Layer_4.png?v=1584615375"
                                  alt="GOBI KIDS"
                                />
                              </div>
                              <div className="det">
                                <p>
                                  Unsere Empfehlung für die Kinder ist die leichte und warme „GOBI KIDS“ Marke. Unser
                                  Garn ist nach den OEKO TEX 100-Standards als hautschonend eingestuft. „GOBI KIDS“
                                  besteht aus leichten, farbenfrohen und fröhlichen Designs. Jedes Design wurde mit
                                  Sorgfalt für Ihre Kinder hergestellt, damit sie zu jeder Jahreszeit warm und bequem
                                  bleiben.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className="global-presence">
                        <div className="sec_tt">
                          <div className="top">
                            <span>5</span>
                            <h2>Teil</h2>
                            <ScrollToTop />
                          </div>
                          <div className="bottom">
                            <h1>GLOBALE GEGENWÄRTIGKEIT</h1>
                          </div>
                        </div>
                        <div className="content">
                          <h2 className="med_tt">FILIALE UND FRANCHISE-GESCHÄFT</h2>
                          <div className="img">
                            <img
                              src="https://cdn.shopify.com/s/files/1/0249/6551/3262/files/Mask_Group_20.png?v=1584613953"
                              alt="GOBI CASHMERE"
                            />
                            <div className="detail">
                              <p>Karte der Filialen und Franchise-Geschäfte von GOBI.</p>
                            </div>
                          </div>
                          <div className="text">
                            <p>
                              International betreibt GOBI neben seinen 54 Franchise-
                              <a href="https://www.gobicashmere.com/de/pages/flagship-store">Geschäften </a> in den
                              grossen Städten der Welt, nämlich London, Prag, Moskau, New York, Brüssel, Mailand, Paris,
                              Seoul und Hongkong, zwei Filialen in Berlin und Hamburg. Darüber hinaus eröffnete GOBI
                              2019 seine brandneuen Online-Shops, angefangen mit "GOBI Cashmere USA". Im Inland verfügt
                              GOBI über 7 Filialen, darunter "The World's Largest Cashmere Store" mit einem 2.500m2
                              großen Kaschmir-Einkaufsgeschäft in der Galleria Mall, die sich neben dem mongolischen
                              Parlamentsgebäude in Ulaanbaatar, Mongolei, befindet.
                            </p>
                          </div>
                        </div>
                        <div className="content" style={{ marginTop: '60px' }}>
                          <h2 className="med_tt">ONLINE-SHOP</h2>
                          <div className="text">
                            <p>
                              Nun konzentriert sich GOBI auf seine vier Online-Shops, um sie der Welt zugänglicher zu
                              machen. Wir glauben, dass es{' '}
                              <a href="https://www.gobicashmere.com/de/pillar/cashmere-is-for-everyone">jeder </a>{' '}
                              verdient, wirklich luxuriöse Kaschmirprodukte zu tragen. Die Mongolei deckt 48% des
                              weltweiten Kaschmirbedarfs, daher ist es für GOBI möglich, seine Produkte aus den feinsten
                              Kaschmirfasern herzustellen, die lokal aus der Mongolei bezogen werden. GOBI ist
                              entschlossen, sein volles Potential auszuschöpfen, um den Kunden Kaschmirprodukte höchster
                              Qualität zum günstigsten Preis zu liefern - unabhängig von Alter, Geschlecht, Nationalität
                              und Standort.
                            </p>
                          </div>
                          <div className="grid">
                            <div className="col-12 online-sto">
                              <ul>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop International</p>
                                    <a href="https://www.gobicashmere.com">www.gobicashmere.com</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop USA</p>
                                    <a href="https://www.gobicashmere.com/us">www.gobicashmere.com/us</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop Deutschland</p>
                                    <a href="https://www.gobicashmere.com/de">www.gobicashmere.com/de</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop Großbritannien</p>
                                    <a href="https://www.gobicashmere.com/uk">www.gobicashmere.com/uk</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop Russland</p>
                                    <a href="https://www.gobicashmere.com/ru">www.gobicashmere.com/ru</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop Polen</p>
                                    <a href="https://www.gobicashmere.com/pl">www.gobicashmere.com/pl</a>
                                  </div>
                                </li>
                                <li>
                                  <div className="det">
                                    <p>Online-Shop Frankreich</p>
                                    <a href="https://www.gobicashmere.com/fr">www.gobicashmere.com/fr</a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </StickyContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
